import { ICarouselProducts } from './types';
import { CarouselProducts } from './CarouselProducts';
import { ICarouselCard } from '@monofront/types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapCarouselProducts } from './mapCarouselProducts';

const DefaultCarouselProducts: React.FC<ICarouselProducts> = ({
  title,
  textLink,
  text,
  items,
  handle,
  trackingId,
  cardTitle,
  cardDescription,
  cardLinkLabel,
  cardLink,
  cardBackgroundColor,
  cardIllustration,
  cardTrackingId,
  position,
}) => {
  let card: ICarouselCard | undefined = undefined;

  if (cardTitle || cardDescription) {
    card = {
      title: cardTitle,
      description: cardDescription,
      label: cardLinkLabel,
      link: cardLink,
      backgroundColor: cardBackgroundColor,
      illustration: cardIllustration,
      trackingId: cardTrackingId,
    };
  }

  return (
    <CarouselProducts
      card={card}
      content={{ title, textLink, text, items, handle, trackingId }}
      position={position}
    />
  );
};

export default withSlice(DefaultCarouselProducts, mapCarouselProducts);
